import { Input } from './Ui';

/**
 * The partner's own rows of detail - "Warranty: 30 days", "Tyre size:
 * 185/65 R15". Admin's category questions are asked elsewhere; these are
 * whatever else this business wants its customers to see, in its own words.
 */
const SpecFields = ({
  label = 'Custom fields',
  hint,
  keyPlaceholder = 'Detail',
  valuePlaceholder = 'Value',
  value = [],
  onChange,
}) => (
  <>
    <label className="field-label">{label}</label>
    {hint ? <div className="t-tiny" style={{ marginBottom: 6 }}>{hint}</div> : null}
    {value.map((spec, i) => (
      <div className="row" key={`spec-${i}`} style={{ gap: 8, alignItems: 'center' }}>
        <Input
          placeholder={keyPlaceholder}
          className="grow"
          value={spec.key}
          onChange={(e) => onChange(value.map((s, x) => (x === i ? { ...s, key: e.target.value } : s)))}
        />
        <Input
          placeholder={valuePlaceholder}
          className="grow"
          value={spec.value}
          onChange={(e) => onChange(value.map((s, x) => (x === i ? { ...s, value: e.target.value } : s)))}
        />
        <button type="button" className="link-btn" onClick={() => onChange(value.filter((_, x) => x !== i))}>✕</button>
      </div>
    ))}
    <button type="button" className="link-btn" onClick={() => onChange([...value, { key: '', value: '' }])}>
      + Add a field
    </button>
  </>
);

export default SpecFields;
